import * as React from "react";

// Icons

interface IUserCenter {};
class UserCenter extends React.Component<IUserCenter> {
    render() {
        return (
            <div className="UserCenter">
                <div className="UserCenter__logo">
                    <span>Rock the JVM</span>
                </div>
                <div className="UserCenter__avatar">
                    <div className="UserCenter__avatar--photo">
                        <img src="/assets/images/courses/scala.png" alt=""/>
                    </div>
                    <div className="UserCenter__avatar--name">
                        <span>Linh duong</span>
                    </div>
                </div>

                <div className="UserCenter__control">
                    <div className="UserCenter__control--icon"><i className="fas fa-cog"></i></div>
                    <div className="UserCenter__control--icon"><i className="fas fa-question-circle"></i></div>
                    <div className="UserCenter__control--icon"><i className="fas fa-sign-out-alt"></i></div>
                </div>
            </div>
        )
    }
}

export default UserCenter;



// WEBPACK FOOTER //
// ./src/components/sidebar/UserCenter.tsx